module.exports = __webpack_public_path__ + "static/media/12.RPEX9.fc9ebbf0.jpg";